module.exports = __webpack_public_path__ + "static/media/instagram.69a36267.png";